/**
 * @desc 根据箱号批次号查询箱号列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierBox.getBoxCodeListByBoxCodeBatchNumberPdf.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierBox/getBoxCodeListByBoxCodeBatchNumberPdf`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
